import React from 'react'
import { Alert, Box, Chip, Grid, LinearProgress, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'
// import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded'
// import EventRoundedIcon from '@mui/icons-material/EventRounded'
import SyncRoundedIcon from '@mui/icons-material/SyncRounded'
import { AnimatedSection, AnimatedTableRow } from '../../components/animations/MotionContainers'
import { MetricCard } from '../../components/dashboard/MetricCard'
import { API_REQUESTS_PAUSED } from '../../data'
import { getIntegrations } from '../../services/admin/integrationsApi'
import { getUpcomingSchedules } from '../../utils/adminIntegrationData'
import { getApiErrorMessage, getPaginatedItems } from '../../utils/apiData'

/* Cálculos de las tarjetas ocultas temporalmente.
const isToday = (value) => {
  const date = new Date(value)
  const today = new Date()
  return !Number.isNaN(date.getTime())
    && date.getFullYear() === today.getFullYear()
    && date.getMonth() === today.getMonth()
    && date.getDate() === today.getDate()
}

const isNextHour = (value) => {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return false
  const now = Date.now()
  return date.getTime() >= now && date.getTime() <= now + 60 * 60 * 1000
}
*/

const buildMetrics = (schedules, integrations) => {
  const activeServices = integrations.filter((integration) => integration.active !== false).length
  // const monitored = schedules.filter((schedule) => schedule.tone === 'warning').length

  return [
    // { title: 'Próxima hora', value: String(schedules.filter((schedule) => isNextHour(schedule.nextRun)).length), action: 'Ver calendario', icon: <AccessTimeRoundedIcon /> },
    // { title: 'Programadas hoy', value: String(schedules.filter((schedule) => isToday(schedule.nextRun)).length), action: 'Plan diario', icon: <EventRoundedIcon /> },
    { title: 'Servicios activos', value: String(activeServices), action: 'Integraciones', icon: <SyncRoundedIcon />, path: '/admin/integraciones' },
    // { title: 'Vigiladas', value: String(monitored), action: 'Revisar', icon: <AccessTimeRoundedIcon /> },
  ]
}

export const AdminUpcomingExecutions = () => {
  const [integrations, setIntegrations] = React.useState([])
  const [schedules, setSchedules] = React.useState([])
  const [loading, setLoading] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState('')
  const metrics = React.useMemo(() => buildMetrics(schedules, integrations), [integrations, schedules])

  React.useEffect(() => {
    if (API_REQUESTS_PAUSED) return undefined

    let active = true

    const loadSchedules = async () => {
      setLoading(true)
      setErrorMessage('')

      try {
        const response = await getIntegrations({ page: 1, limit: 500, sortDirection: 'asc' })
        const apiIntegrations = getPaginatedItems(response)
        if (!active) return
        setIntegrations(apiIntegrations)
        setSchedules(getUpcomingSchedules(apiIntegrations))
      } catch (error) {
        if (active) setErrorMessage(getApiErrorMessage(error, 'No se han podido cargar las próximas ejecuciones.'))
      } finally {
        if (active) setLoading(false)
      }
    }

    loadSchedules()

    return () => {
      active = false
    }
  }, [])

  return (
    <Box className="page-fade">
      <Box className="page-heading">
        <Typography variant="h4">Próximas ejecuciones</Typography>
        <Typography>Calendario inmediato de procesos programados y ventanas de ejecución previstas.</Typography>
      </Box>

      <Grid container spacing={2.1}>
        {metrics.map((metric) => (
          <Grid key={metric.title} size={{ xs: 12, sm: 6, lg: 3 }}>
            <MetricCard {...metric} />
          </Grid>
        ))}
      </Grid>

      <AnimatedSection><Box className="dashboard-section-card admin-panel-card admin-page-section">
        <Typography className="section-title">Calendario operativo</Typography>
        {loading && <LinearProgress sx={{ mb: 1.5 }} />}
        {errorMessage && <Alert severity="warning" sx={{ mb: 1.5 }}>{errorMessage}</Alert>}
        <Box className="activity-table-wrap">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Hora</TableCell>
                <TableCell>Proceso</TableCell>
                <TableCell>Integración</TableCell>
                <TableCell>Frecuencia</TableCell>
                <TableCell>Ventana</TableCell>
                <TableCell>Estado</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {schedules.map((execution) => (
                <TableRow component={AnimatedTableRow} key={execution.id} hover>
                  <TableCell>{execution.time}</TableCell>
                  <TableCell>{execution.process}</TableCell>
                  <TableCell className="admin-execution-type">{execution.integration}</TableCell>
                  <TableCell>{execution.frequency}</TableCell>
                  <TableCell>{execution.nextWindow}</TableCell>
                  <TableCell>
                    <Chip size="small" className={`admin-status-chip admin-status-${execution.tone}`} label={execution.status} />
                  </TableCell>
                </TableRow>
              ))}
              {!loading && schedules.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6}>
                    <Typography className="admin-user-empty">No hay próximas ejecuciones programadas.</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
      </Box></AnimatedSection>
    </Box>
  )
}
